import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import NewsletterSignup from "../components/NewsletterSignup";
import { api } from "../lib/api";
import { useLang } from "../lib/lang";
import { ArrowUpRight } from "lucide-react";

function fmtDate(iso) {
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return iso;
  }
}

export default function NewsListPage() {
  const { t, tri } = useLang();
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("All");

  useEffect(() => {
    const q = cat === "All" ? "" : `?category=${encodeURIComponent(cat)}`;
    api.get(`/news${q}`).then((r) => setItems(r.data)).catch(() => {});
  }, [cat]);

  const cats = ["All", "Statements", "Humanitarian", "Operations", "Events", "General"];

  return (
    <div className="App" data-testid="news-list-page">
      <Header />
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="border-b border-slate-200 pb-6 mb-10">
          <div className="text-xs uppercase tracking-[0.3em] text-red-600 font-semibold mb-2">
            {t("hero_section")}
          </div>
          <h1 className="font-display text-5xl sm:text-6xl text-slate-900">{t("nav_news")}</h1>
        </div>

        <div className="flex gap-2 flex-wrap mb-10" data-testid="news-categories">
          {cats.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              data-testid={`news-cat-${c.toLowerCase()}`}
              className={`px-4 py-2 text-xs uppercase tracking-[0.2em] font-semibold border transition ${
                cat === c
                  ? "bg-slate-900 text-white border-slate-900"
                  : "bg-white text-slate-700 border-slate-300 hover:border-slate-900"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {items.length === 0 ? (
          <div className="text-slate-500 py-12" data-testid="news-empty">{t("no_data")}</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {items.map((n, i) => (
              <Link
                to={`/news/${n.id}`}
                key={n.id}
                data-testid={`news-item-${i}`}
                className="kn-card group bg-white border border-slate-200"
              >
                <div className="aspect-[4/3] overflow-hidden bg-slate-100">
                  {n.image_url && (
                    <img src={n.image_url} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  )}
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between text-xs uppercase tracking-[0.2em] mb-3">
                    <span className="text-red-600 font-semibold">{n.category}</span>
                    <span className="text-slate-500">{fmtDate(n.created_at)}</span>
                  </div>
                  <h3 className="font-display text-2xl text-slate-900 leading-tight mb-3">{tri(n.title)}</h3>
                  <p className="text-sm text-slate-600 line-clamp-3">{tri(n.excerpt)}</p>
                  <div className="mt-4 inline-flex items-center gap-1 text-xs uppercase tracking-[0.2em] font-semibold group-hover:text-red-600 transition">
                    {t("read_more")} <ArrowUpRight className="w-3 h-3" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
      <NewsletterSignup variant="dark" />
      <Footer />
    </div>
  );
}
